import { render, staticRenderFns } from "./PanoWhiteboard.vue?vue&type=template&id=7406134f&scoped=true&"
import script from "./PanoWhiteboard.vue?vue&type=script&lang=js&"
export * from "./PanoWhiteboard.vue?vue&type=script&lang=js&"
import style0 from "./PanoWhiteboard.vue?vue&type=style&index=0&id=7406134f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7406134f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7406134f')) {
      api.createRecord('7406134f', component.options)
    } else {
      api.reload('7406134f', component.options)
    }
    module.hot.accept("./PanoWhiteboard.vue?vue&type=template&id=7406134f&scoped=true&", function () {
      api.rerender('7406134f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classroom1/components/whiteboard/PanoWhiteboard.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/whiteboard/PanoWhiteboard.vue
// module id = nm5X
// module chunks = 0